// Shared content for Bridge Advisors LLP

export const SERVICES = [
  {
    id: "bookkeeping",
    num: "01",
    title: "Bookkeeping",
    short: "Reliable day-to-day records that support reporting accuracy and operational visibility.",
    desc: "Meticulous transaction management, reconciliations, and ledger hygiene that keep your books audit-ready and your leadership informed — maintained on US-aligned reporting cycles.",
    points: ["General ledger management", "Bank & credit reconciliations", "Accounts payable / receivable", "Monthly close support"],
  },
  {
    id: "accounting",
    num: "02",
    title: "Accounting",
    short: "Structured support for month-end close, reconciliations, and financial statement readiness.",
    desc: "Disciplined accounting operations built around US GAAP — from close orchestration to financial statement preparation that stands up to investor and lender scrutiny.",
    points: ["US GAAP financial statements", "Month & year-end close", "Revenue recognition", "Audit preparation"],
  },
  {
    id: "cfo-advisory",
    num: "03",
    title: "CFO Advisory",
    short: "Strategic finance guidance for planning, cash flow oversight, and executive decisions.",
    desc: "Senior-level financial leadership on demand. We partner with founders and boards on forecasting, capital strategy, and the numbers behind every major decision.",
    points: ["Budgeting & forecasting", "Cash flow strategy", "Board & investor reporting", "KPI & unit economics"],
  },
  {
    id: "cost-optimization",
    num: "04",
    title: "Cost Optimization",
    short: "Targeted analysis to identify savings and improve financial efficiency across operations.",
    desc: "We surface margin leakage and structural inefficiency, then build a defensible plan to reclaim it — without compromising growth or controls.",
    points: ["Spend analysis", "Vendor rationalization", "Margin improvement", "Process automation"],
  },
  {
    id: "standards-implementation",
    num: "05",
    title: "Standards Implementation",
    short: "Practical support for new accounting standards and evolving reporting requirements.",
    desc: "From ASC transitions to policy design, we operationalize new standards with documentation, controls, and training your team can actually sustain.",
    points: ["ASC 606 / 842 adoption", "Accounting policy design", "Control documentation", "Team enablement"],
  },
  {
    id: "complex-transactions",
    num: "06",
    title: "Complex Transactions",
    short: "Experienced support for technically demanding transactions and finance transformations.",
    desc: "M&A, restructurings, and technical accounting matters handled with the rigor they demand — and translated into language your stakeholders trust.",
    points: ["M&A accounting", "Technical memos", "Due diligence support", "Finance transformation"],
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Disciplined by design",
    body: "Clean books are not an accident. We build repeatable processes and controls so your financials are accurate the first time — and every time after.",
  },
  {
    num: "02",
    title: "Senior, not surface-level",
    body: "You work directly with experienced advisors, not a rotating bench of juniors. The person reviewing your numbers is the person who understands your business.",
  },
  {
    num: "03",
    title: "Built for US operators",
    body: "US GAAP fluency, US time-zone availability, and secure remote operations. We fit the way American finance teams and their stakeholders expect to work.",
  },
];

export const STATS = [
  { value: "US GAAP", label: "Reporting standard fluency" },
  { value: "EST–PST", label: "US time-zone availability" },
  { value: "Senior", label: "Advisor-led engagements" },
  { value: "Secure", label: "Remote operations" },
];

export const CONTACT = {
  phone: "(91) 6289606912",
  email: "contact@bridgeadvisors1991@gmail.com",
  availability: "Serving clients remotely and by appointment",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/8353820/pexels-photo-8353820.jpeg",
  advisory: "https://images.unsplash.com/photo-1577415124269-fc1140a69e91?crop=entropy&cs=srgb&fm=jpg&q=85",
  architecture: "https://images.pexels.com/photos/34764468/pexels-photo-34764468.jpeg",
  manifesto: "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&q=85",
};
